var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftbb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "matrix(-1 0 0 1 41 0)",
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2929 21.7071C10.9024 21.3166 10.9024 20.6834 11.2929 20.2929L17.6569 13.9289C18.0474 13.5384 18.6805 13.5384 19.0711 13.9289C19.4616 14.3195 19.4616 14.9526 19.0711 15.3431L13.4142 21L19.0711 26.6569C19.4616 27.0474 19.4616 27.6805 19.0711 28.0711C18.6805 28.4616 18.0474 28.4616 17.6569 28.0711L11.2929 21.7071ZM29 22H12V20H29V22Z",
    fill: "#1B1E70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftbb);
export default __webpack_public_path__ + "static/media/leftbb.e289395a9af368088c4a5f4c26e1336a.svg";
export { ForwardRef as ReactComponent };